import Chart from 'chart.js/auto'
import {OA_TYPES, OA_TYPES_BG_COLORS} from './config';
import _ from 'lodash';

export default class StackedBarChartPublishers {

  constructor(elementId, data) {
    this.elementId = elementId;
    this.data = data;
    this.initYearSelector();
    this.initDatasets();
    
    this.addGraph();
  }

  initDatasets() {
    this.datasets = []
    this.publishers = this.getPublishersSortedByPublicationCount()

    for (const oatype of OA_TYPES) {
      const dataset = {
        label: oatype,
        data: [],
        backgroundColor: OA_TYPES_BG_COLORS[oatype],
      }

      for (const publisher of this.publishers) {
        dataset.data.push(
          this.getCountByPublisherAndOaType(publisher[0], oatype)
        )
      }

      this.datasets.push(dataset)
    }
  }

  initYearSelector() {
    this.yearSelector = document.getElementById('pbp-year-selector')
    this.selectedYear = this.yearSelector.value

    this.yearSelector.addEventListener('change', (event) => {
      this.selectedYear = event.target.value

      if (this.selectedYear) {
        this.initDatasets()

        // Update chart
        this.chart.data.datasets = this.datasets
        this.chart.data.labels = this.getLabels()
        this.chart.update()
      }
    })
  }


  getPublishers() {
    const selectedData = this.data[this.selectedYear]["oa_publisher_aggregation"]
    const publishers = selectedData.map((elem) => elem["_id"]["publisher"])
    const uniquePublishers = [...new Set(publishers)]

    return uniquePublishers
  }

  getPublishersSortedByPublicationCount() {
    const publishers = this.getPublishers()
    
    const totalPublicationCnt = {}
    for (const publisher of publishers) {
      totalPublicationCnt[publisher] = 0
    }

    for (const publisher of publishers) {
      const publications = this.data[this.selectedYear]["oa_publisher_aggregation"].filter(
        (elem) => elem["_id"]["publisher"] === publisher
      )
      for (const publication of publications) {
        totalPublicationCnt[publisher] += publication.count
      }
    }

    let sortable = []
    for (const publisher in totalPublicationCnt) {
      sortable.push([publisher, totalPublicationCnt[publisher]])
    }

    sortable.sort(function(a, b) {
      return a[1] - b[1];
    });

    return sortable.map((elem => [elem[0], elem[1]])).reverse().slice(0,15)
  }

  getCountByPublisherAndOaType(publisher, type) {
    const seletedData = this.data[this.selectedYear]["oa_publisher_aggregation"]
    try {
      return seletedData.find((elem) => elem["_id"]["publisher"] === publisher && elem["_id"]["oatype"] === type).count
    } catch (error) {
      return 0
    }
  }

  getLabels() {
    const publishers = this.getPublishersSortedByPublicationCount();
    return publishers.map((publisher) => `${publisher[0]} (${publisher[1]})`)
  }

  addGraph() {
    const data = {
      labels: this.getLabels(),
      datasets: this.datasets
    };

    this.chart = new Chart(
      document.getElementById(this.elementId),
        {
          type: 'bar',
          data: data,
          options: {
            indexAxis: 'y',
            scales: {
              x: {
                stacked: true
              },
              y: {
                stacked: true
              }
            }
          }
        }
    );
  }
}
